const PlanEvent = {
  fetchOne: 'plan/fetch-one',
  onClear: 'plan/on-clear',
  onEdit: 'plan/on-edit',
  onEditSearchCondition: 'plan/on-edit-search-condition',
  onSearch: 'plan/on-search'
}

export default PlanEvent
